export enum CollectionType {
  Editable = "Editable",
  Featured = "Featured",
  Listed = "Listed",
}
